import React from 'react'
import { FormControl, FormControlLabel, Checkbox as MuiCheckbox } from '@material-ui/core';

export default function Checkbox(props) {

    const { id, name, label, checked, onChange, ...others } = props;


    const convertToDefEventPara = (name, value) => ({
        target: {
            name, value
        }
    })

    return (
        <FormControl>
            <FormControlLabel
                control={<MuiCheckbox
                    id={id}
                    name={name}
                    color="primary"
                    checked={checked}
                    onChange={onChange}
                    {...others}
                />}
                label={label}
            />
        </FormControl>
    )
}
